import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { AuthLayout } from "../components/AuthLayout";
import { Button, Field, Input, Alert, Spinner } from "../components/ui";

export function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ displayName: "", email: "", password: "", memberCode: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const res = await register(form);
      navigate("/gear/verify", { state: { email: form.email, devCode: res.devCode } });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      title="Create your account"
      subtitle="The Gear Exchange is open to Sartell Soccer members only."
      footer={
        <>
          Already have an account?{" "}
          <Link to="/gear/login" className="text-brand-600 font-semibold hover:underline">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Field label="Your name">
          <Input required value={form.displayName} onChange={set("displayName")} placeholder="Jordan Smith" />
        </Field>
        <Field label="Email">
          <Input
            type="email"
            autoComplete="email"
            required
            value={form.email}
            onChange={set("email")}
            placeholder="you@example.com"
          />
        </Field>
        <Field label="Password" hint="At least 8 characters.">
          <Input
            type="password"
            autoComplete="new-password"
            required
            minLength={8}
            value={form.password}
            onChange={set("password")}
            placeholder="••••••••"
          />
        </Field>
        <Field label="SSA member code" hint="Ask your club admin if you don't have one.">
          {/* Never put the real member code here — the placeholder is visible to
              anyone who loads this page, which would defeat the gate entirely. */}
          <Input required value={form.memberCode} onChange={set("memberCode")} placeholder="Enter your member code" />
        </Field>
        <Alert>{error}</Alert>
        <Button type="submit" disabled={busy} className="w-full">
          {busy ? <Spinner /> : "Create account"}
        </Button>
      </form>
    </AuthLayout>
  );
}
